<template>
  <del-dialog width="1100px" :dialogVisible="dialogVisible" @handleOpen="handleOpen" :showClose="false" :showButton="true" :showConfirmButton="false" @handleClose="handleClose" @handleConfirm="handleConfirm" @handleClosed="handleClosed">
    <template #title>{{$t('assignTaskV2.watch')}}</template>
    <div class="preview-file">
      <el-table height="100%" border :data="sentList" header-row-class-name="customHeader">
        <el-table-column align="center" :label="$t('projectV2.index')" width="60" :resizable="false">
          <template slot-scope="{ $index }">{{(query.page - 1) * query.rows + $index + 1}}</template>
        </el-table-column>
        <el-table-column align="left" :label="$t('projectDetailsV2.originalText')" :resizable="false" prop="sourceSent"></el-table-column>
        <el-table-column v-if="queryData.isPreMt === 1" align="left" :label="$t('projectDetailsV2.translateText')" :resizable="false" prop="mtTargetSent"></el-table-column>
      </el-table>
    </div>
    <div class="preview-pagination">
      <el-pagination background layout="prev, pager, next, sizes" :pager-count="5" :current-page="query.page" :page-sizes="[10, 20, 30]" :page-size="query.rows" :total="totalRows" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
    </div>
  </del-dialog>
</template>

<script>
import DelDialog from '@/components/delDialog';

import { viewHomeWorkPage } from '@/services/jobManagement';

export default {
  name: 'PreviewFile',
  components: {
    DelDialog,
  },
  props: {
    dialogVisible: {
      type: Boolean,
      require: true,
    },
    queryData: {
      type: Object,
      require: true,
    },
  },
  data () {
    return {
      // queryData: {},
      sentList: [],
      query: {
        filter: {
          projectId: null,
          transFileId: null,
        },
        page: 1,
        rows: 10,
      },
      totalRows: 0,

      // 切换团队不影响使用的companyCode
      companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany.code,
    }
  },
  mounted () {
    // this.queryData = JSON.parse(this.$Base64.decode(this.$route.query.key));
  },
  methods: {
    handleConfirm () {

    },
    handleClosed () {
      this.query = {
        filter: {
          projectId: null,
          transFileId: null,
        },
        page: 1,
        rows: 10,
      };
    },
    handleClose () {
      this.$emit('handleClose');
    },
    async splitTaskPreViewDetail () {
      this.query.filter.companyCode = this.companyCode;
      let { success, list, totalRows } = await viewHomeWorkPage(this.query);
      if (!success) { return; }
      this.sentList = list;
      this.totalRows = totalRows;
    },
    handleOpen () {
      this.query.filter.projectId = this.queryData.projectId;
      this.query.filter.transFileId = this.queryData.id;
      this.splitTaskPreViewDetail();
    },
    handleSizeChange (val) {
      this.query.rows = val;
      this.splitTaskPreViewDetail();
    },
    handleCurrentChange (val) {
      this.query.page = val;
      this.splitTaskPreViewDetail();
    },
  },
}
</script>

<style lang="less" scoped>
.preview-file {
  line-height: 1.5;
  height: 370px;
  /deep/.el-table__body-wrapper .cell {
    color: #666;
  }
  /deep/.customHeader {
    th {
      background: #F3F7FE;
      color: #566087;
      font-weight: bold;
    }
  }
  /deep/.el-table-column--selection {
    .cell {
      padding: 0 10px;
    }
  }
  /deep/.el-table__row td .cell {
    // white-space: pre-wrap;
    // /* 这两个在技术上是一样的, 为了兼容了浏览器两个都加上 */
    // overflow-wrap: break-word;
    // word-wrap: break-word;

    // -ms-word-break: break-all;
    // /* 这个的使用在web-kit中有些危险，他可能会阶段所有东西 */
    // word-break: break-all;
    // /* Instead use this non-standard one: */
    // word-break: break-word;

    // /* 如果浏览器支持的话增加一个连接符(Blink不支持) */
    // -ms-hyphens: auto;
    // -moz-hyphens: auto;
    // -webkit-hyphens: auto;
    // hyphens: auto;
    word-break: break-word;
  }
}
.preview-pagination {
  margin-top: 30px;
  /deep/.btn-prev {
    background: none;
    border: 1px solid #C0CCCC;
  }
  /deep/.number{
    background: none;
    border: 1px solid #C0CCCC;
  }
  /deep/.el-icon-more{
    background: #FFFFFF;
  }
  /deep/.btn-next{
    background: none;
    border: 1px solid #C0CCCC;
  }
  /deep/.el-pagination__sizes{
    margin-right: -10px;
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    border: 1px solid #0087fc;
    border-radius: 4px;
    background: #FFFFFF;
    color: #0078fc;
  }
  /deep/.el-pagination.is-background .el-pager li {
    background: #FFFFFF;
  }
}
</style>